import { ConfirmDialog } from '@/components/confirm-dialog'
import { listAttendantsQuery } from '@/queries/attendant.query'
import { AttendantService } from '@/services/attendant.service'
import { useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { useAttendants } from '../context/attendants-context'
import { AttendantsMutateDrawer } from './attendants-mutate-drawer'

export function AttendantsDialogs() {
  const { open, setOpen, currentRow, setCurrentRow } = useAttendants()
  const queryClient = useQueryClient()

  return (
    <>
      <AttendantsMutateDrawer
        key='attendant-create'
        open={open === 'create'}
        onOpenChange={() => setOpen('create')}
      />

      {currentRow && (
        <>
          <AttendantsMutateDrawer
            key={`attendant-update-${currentRow.id}`}
            open={open === 'update'}
            onOpenChange={() => {
              setOpen('update')
              setTimeout(() => {
                setCurrentRow(null)
              }, 500)
            }}
            currentRow={currentRow}
          />

          <ConfirmDialog
            key='attendant-delete'
            destructive
            open={open === 'delete'}
            onOpenChange={() => {
              setOpen('delete')
              setTimeout(() => {
                setCurrentRow(null)
              }, 500)
            }}
            handleConfirm={() => {
              setOpen(null)
              setCurrentRow(null)
              toast.promise(AttendantService.delete(currentRow.id), {
                loading: 'Deletando atendente...',
                success: async () => {
                  await queryClient.invalidateQueries({ queryKey: listAttendantsQuery.queryKey })
                  return 'Atendente deletado'
                },
                error: async () => {
                  await queryClient.invalidateQueries({ queryKey: listAttendantsQuery.queryKey })
                  return 'Erro ao deletar atendente!'
                },
              })
            }}
            className='max-w-md'
            title={`Deletar este atendente: ${currentRow.user.name} ?`}
            desc={
              <>
                Você está prestes a deletar um atendente <strong>{currentRow.user.name}</strong>. <br />
                Esta ação não pode ser revertida.
              </>
            }
            confirmText='Deletar'
          />
        </>
      )}
    </>
  )
} 